/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S1_Body_PreInputs */

const tr_servis_s1_body_pre = /** @type {(inputs: Servis_S1_Body_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu Servis Sözleşmesi, ShopPanel™ aboneliğinin operasyonel hükümlerini kapsar ve `)
};

const en_servis_s1_body_pre = /** @type {(inputs: Servis_S1_Body_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This Service Agreement covers the operational provisions of the ShopPanel™ subscription and is an integral annex to the `)
};

const de_servis_s1_body_pre = /** @type {(inputs: Servis_S1_Body_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Servicevertrag umfasst die operativen Bestimmungen des ShopPanel™ Abonnements und ist ein untrennbarer Anhang der `)
};

const ru_servis_s1_body_pre = /** @type {(inputs: Servis_S1_Body_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настоящий Сервисный договор охватывает операционные положения подписки ShopPanel™ и является неотъемлемым приложением к документу `)
};

/**
* | output |
* | --- |
* | "This Service Agreement covers the operational provisions of the ShopPanel™ subscription and is an integral annex to the" |
*
* @param {Servis_S1_Body_PreInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s1_body_pre = /** @type {((inputs?: Servis_S1_Body_PreInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S1_Body_PreInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s1_body_pre(inputs)
	if (locale === "de") return de_servis_s1_body_pre(inputs)
	if (locale === "ru") return ru_servis_s1_body_pre(inputs)
	return tr_servis_s1_body_pre(inputs)
});